// eslint-disable-next-line no-use-before-define
import React from "react";
import PropTypes from "prop-types";
import PopupLayout from "../popupLayout/popupLayout";

/**
 * ConsentPopupLayout is a specialized popup that only shows an OK button
 * (no cancel button). It wraps PopupLayout with specific configuration.
 *
 * Use this for consent/acknowledgment dialogs where the user only needs
 * to confirm or close, not cancel.
 */
function ConsentPopupLayout({
  show,
  top,
  left,
  bottom,
  right,
  children,
  onOk,
  onCancel,
  disableSave,
  popupRef,
  okKey,
  hideButtons,
  hideClose,
}) {
  return (
    <PopupLayout
      show={show}
      top={top}
      left={left}
      bottom={bottom}
      right={right}
      onOk={onOk}
      onCancel={onCancel}
      disableSave={disableSave}
      popupRef={popupRef}
      okKey={okKey}
      hideButtons={hideButtons}
      hideClose={hideClose}
      showCancelButton={false}
    >
      {children}
    </PopupLayout>
  );
}

ConsentPopupLayout.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
  bottom: PropTypes.number,
  right: PropTypes.number,
  children: PropTypes.node,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  show: PropTypes.bool,
  disableSave: PropTypes.bool,
  popupRef: PropTypes.func,
  okKey: PropTypes.string,
  hideButtons: PropTypes.bool,
  hideClose: PropTypes.bool,
};

ConsentPopupLayout.defaultProps = {
  onOk: () => {},
  onCancel: () => {},
  show: false,
  okKey: "ok",
  hideButtons: false,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  hideClose: false,
  children: null,
  disableSave: false,
  popupRef: () => {},
};

export default ConsentPopupLayout;
